/* eslint-disable no-console */
import * as deliveryAction from '../actions/deliveryAction';
import { endLoading, startLoading } from '../actions/loadingAction';
import { getUrlExpeditionApi, parseParams, showMessageToastCustom, translate } from '../utils/util';
import HttpService from './HttpService';

const httpService = new HttpService(getUrlExpeditionApi(window));

export default class DeliveryService {
    static getOrders(filter, pagination, callback) {
        Object.assign(filter, pagination);
        const url = '/api/delivery/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        dispatch(deliveryAction.setOrders(dados));
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }


    static getQrCode(code, callback) {
        const filter = {};
        filter.code = code;
        const url = '/api/qrcode/bycode';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data?.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getGroupUser(callback) {
        const url = '/api/delivery/groupuser';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(deliveryAction.selectDeliveryGroup(response.data?.data));
                    }
                    if (callback) {
                        callback(response?.data?.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static startDelivery(filter, callback) {
        const url = '/api/delivery';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, filter).then((response) => {
                    if (response.status === 200) {
                        if (response.data?.data) {
                            dispatch(deliveryAction.selectDeliveryGroup(response.data?.data));
                            if (callback) {
                                callback(response.data?.data);
                            }
                        } else {
                            showMessageToastCustom(translate('warning', 'general'), translate('message.noRecordFound', 'delivery'), 8000, 'mdi mdi-alert-circle-outline red-text');
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static writeOffOrder(filter, callback) {
        const url = `api/picking/writeOff/${filter.orderCode}/${filter.orderTypeId}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, filter).then((response) => {
                    if (response.status === 200) {
                        if (response.data) {
                            if (callback) {
                                callback(response.data);
                            }
                        } else {
                            showMessageToastCustom(translate('warning', 'general'), translate('message.noRecordFound', 'delivery'), 8000, 'mdi mdi-alert-circle-outline red-text');
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static checkedItem(filter, callback) {
        const url = '/api/delivery/checkeditem';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, filter).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        response.data.data.forEach((item) => {
                            dispatch(deliveryAction.updateMissionStatus(item.orderItemId, item.status));
                        });
                        if (callback) {
                            callback()
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static FinishDelivery(frame, callback) {
        const url = `/api/delivery/finish?frame=${frame}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    console.log(response);
                    if (response.status === 200 && response.data?.success) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static ConfirmationDeliveryUrgent(idOrder, location, callback) {
        const url = `/api/delivery/confirmation/urgent?location=${location}&id=${idOrder}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(deliveryAction.updateOrder(response.data?.data));
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static ConfirmationDeliveryPdu(data, callback) {
        const url = `/api/delivery/confirmation?location=${data}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(deliveryAction.updateDeliveryGroup(response.data?.data));
                        if (callback) {
                            callback(response.data?.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getDeliveryCall(filter, callback) {
        const url = '/api/delivery/call';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (callback) {
                            callback(response.data?.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getDeliverysPartNumber(partNumber, callback) {
        const url = '/api/delivery/filter';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: { partNumber } }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(deliveryAction.setOrders(response.data?.data));
                        if (callback) {
                            callback(response.data?.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static sendManualCall(items, callback) {
        const url = '/api/delivery/call/send';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, items).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(true)
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static FinishDollyDelivery(idDolly, callback) {
        const url = `/api/delivery/finishDolly?idDolly=${idDolly}`;
        return (dispatch) => {
            if (navigator.onLine) {
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200 && response.data?.success) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static leave(orderGroupId, callback) {
        const url = `/api/delivery/ordergroup/leave`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderGroupId: orderGroupId, leave: true }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        }
    }

    static getPartNumberPdu(pdu, callback) {
        const url = '/api/PartNumberPdu/search';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: { pdu } }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (callback) {
                            callback(response.data?.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    dispatch(endLoading());
                })
            }
        };
    }

    static AddAreaPdu = (data, callback) => {
        const url = 'api/AreaPdu';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, data, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response?.data?.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static PutAreaPdu = (area, data, callback) => {
        const url = `api/AreaPdu/${area}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, data, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static GetAreaPdu = (data, callback) => {
        const url = 'api/AreaPdu';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: data }, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response?.data?.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }
}
